// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3z-G-","name":"Header_name__3JoB3","birthday":"Header_birthday__1q0L9","skeleton":"Header_skeleton__PTOBZ"};